export enum Category {
  Absence = 'ABSENCE',
  Holiday = 'HOLIDAY',
  Event = 'EVENT',
  Course = 'COURSE',
  Service = 'SERVICE',
  Organization = 'ORGANIZATION',
  Private = 'PRIVATE',
}
